import { makeStyles, createStyles } from '@material-ui/core/styles';
import type { Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
    createStyles({
        /* Styles applied to the root element. */
        root: {
            flex: '1 1',
            display: 'flex',
            '&$focused > [class*="MuiOutlinedAddon-root"]': {
                borderColor: theme.palette.primary.main,
                color: theme.palette.primary.main,
            },
            '&$error > [class*="MuiOutlinedAddon-root"]': {
                borderColor: theme.palette.error.main,
                color: theme.palette.error.main,
            },
            '&$disabled > [class*="MuiOutlinedAddon-root"]': {
                borderColor: theme.palette.action.disabledBackground,
            },
        },
        /* Pseudo-class applied to the root element if `error={true}`. */
        error: {
            '& [class*="MuiInputRightAddon-root"]': {
                borderColor: theme.palette.error.main,
                color: theme.palette.error.main,
            },
            '& [class*="MuiInputLeftAddon-root"]': {
                borderColor: theme.palette.error.main,
                color: theme.palette.error.main,
            },
        },
        /* Styles applied to the root element if `disabled={true}`. */
        disabled: {
            '& [class*="MuiInputRightAddon-root"]': {
                borderColor: theme.palette.action.disabledBackground,
            },
            '& [class*="MuiInputLeftAddon-root"]': {
                borderColor: theme.palette.action.disabledBackground,
            },
        },
        /* Styles applied to the root element if `position="start"`. */
        positionStart: {
            '& [class*="MuiOutlinedInput-notchedOutline"]': {
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
            },
            '& [class*="MuiFormHelperText-root"]': {
                marginLeft: -24,
            },
        },
        /* Styles applied to the root element if `position="end"`. */
        positionEnd: {
            '& [class*="MuiOutlinedInput-notchedOutline"]': {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
            },
            '& [class*="MuiFormHelperText-root"]': {
                marginRight: -24,
            },
        },
        /* Styles applied to the root element if `position="start-end"`. */
        positionStartEnd: {
            '& [class*="MuiOutlinedInput-notchedOutline"]': {
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
            },
            '& [class*="MuiFormHelperText-root"]': {
                marginLeft: -24,
                marginRight: -24,
            },
        },
        focused: {},
    });

export default makeStyles(styles, { name: 'MuiOutlinedAdornment' });
